/**
 * Wrapper genérico para llamadas API con manejo de errores 422
 * @param {Function} fn - Función API a ejecutar
 * @param  {...any} args - Argumentos para la función
 * @returns {Promise} - response.data
 */
export async function apiCall(fn, ...args) {
  try {
    const response = await fn(...args);
    return response.data;
  } catch (error) {
    const data = error.response.data || {};
    // Caso a): errores de validación Laravel (FormRequest)
    if (data.errors && typeof data.errors === 'object') {
      const firstKey = Object.keys(data.errors)[0];
      if (firstKey) {
        error.error_msg = data.errors[firstKey][0];
      }
    }

    // Caso b): error a nivel de app — preferimos message si existe
    if (data.message) {
      error.error_msg = data.message;
    }

    // Caso c): el backend manda error_msg directo (custom controllers)
    if (data.error_msg) {
      error.error_msg = data.error_msg;
    }

    // Exponer el código de error para que el caller pueda decidir
    // (ej. abortar el loop si es schema_mismatch o unsupported_layer)
    if (data.error) {
      error.error_code = data.error;
    }
    throw error;
  }
}
